import { Skeleton } from '@/components/ui/skeleton';

export const LogTableSkeleton = () => (
  <div className="space-y-4">
    {/* Table Header */}
    <div className="rounded-lg overflow-hidden border border-gray-200 bg-white">
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left table-auto rounded-lg">
          <thead className="text-xs bg-[#ECF0F7]">
            <tr>
              <th className="p-3 w-4">
                <Skeleton className="h-4 w-8" />
              </th>
              <th className="p-3 min-w-32">
                <Skeleton className="h-4 w-16" />
              </th>
              <th className="p-3 min-w-32">
                <Skeleton className="h-4 w-16" />
              </th>
              <th className="p-3 min-w-32">
                <Skeleton className="h-4 w-16" />
              </th>
              <th className="p-3 min-w-32">
                <Skeleton className="h-4 w-12" />
              </th>
              <th className="p-3 min-w-32">
                <Skeleton className="h-4 w-24" />
              </th>
            </tr>
          </thead>
          <tbody>
            {[...Array(10)].map((_, index) => (
              <tr key={index} className="bg-white border-b">
                <td className="p-3">
                  <Skeleton className="h-4 w-8" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-4 w-32" />
                </td>
                <td className="p-3">
                  <div className="space-y-1">
                    <Skeleton className="h-4 w-24" />
                    <Skeleton className="h-3 w-16" />
                  </div>
                </td>
                <td className="p-3">
                  <Skeleton className="h-4 w-40" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-4 w-20" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-4 w-28" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Pagination Skeleton */}
      <div className="flex items-center justify-between px-5 py-3 border-t border-gray-200">
        <Skeleton className="h-4 w-32" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-8 rounded" />
          <Skeleton className="h-8 w-8 rounded" />
          <Skeleton className="h-8 w-8 rounded" />
          <Skeleton className="h-8 w-20" />
        </div>
      </div>
    </div>
  </div>
);
